import { render, staticRenderFns } from "./salse.vue?vue&type=template&id=ff1a308e&"
import script from "./salse.vue?vue&type=script&lang=js&"
export * from "./salse.vue?vue&type=script&lang=js&"
import style0 from "./salse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports